import axios from 'axios'
import { Message } from 'element-ui'

const defaultBaseURL =
  process.env.NODE_ENV === 'development' ? '/api' : 'https://yinuojiajiao.cn/prod-api'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || defaultBaseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      'Request failed'

    Message.error(message)
    return Promise.reject(error)
  }
)

function request(config) {
  return service(config)
}

export function get(url, params = {}, config = {}) {
  return request({
    url,
    method: 'get',
    params,
    ...config
  })
}

export function post(url, data = {}, config = {}) {
  return request({
    url,
    method: 'post',
    data,
    ...config
  })
}

export function put(url, data = {}, config = {}) {
  return request({
    url,
    method: 'put',
    data,
    ...config
  })
}

export function del(url, params = {}, config = {}) {
  return request({
    url,
    method: 'delete',
    params,
    ...config
  })
}

export function upload(url, data, config = {}) {
  return request({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  })
}

export default request
